/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPresignedUrlRequestResponse
 */
export interface GetPresignedUrlRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPresignedUrlRequestResponse
     */
    logId: string;
    /**
     * 
     * @type {string}
     * @memberof GetPresignedUrlRequestResponse
     */
    uploadUrl: string | null;
}

/**
 * Check if a given object implements the GetPresignedUrlRequestResponse interface.
 */
export function instanceOfGetPresignedUrlRequestResponse(value: object): value is GetPresignedUrlRequestResponse {
    if (!('logId' in value) || value['logId'] === undefined) return false;
    if (!('uploadUrl' in value) || value['uploadUrl'] === undefined) return false;
    return true;
}

export function GetPresignedUrlRequestResponseFromJSON(json: any): GetPresignedUrlRequestResponse {
    return GetPresignedUrlRequestResponseFromJSONTyped(json, false);
}

export function GetPresignedUrlRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPresignedUrlRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'logId': json['logId'],
        'uploadUrl': json['uploadUrl'],
    };
}

export function GetPresignedUrlRequestResponseToJSON(json: any): GetPresignedUrlRequestResponse {
    return GetPresignedUrlRequestResponseToJSONTyped(json, false);
}

export function GetPresignedUrlRequestResponseToJSONTyped(value?: GetPresignedUrlRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logId': value['logId'],
        'uploadUrl': value['uploadUrl'],
    };
}

